<template>
  <el-row :gutter="15" class="wrapper">
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">待确认订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { state_in: ['wait_supplier_confirm'] } }">
              <p class="value">{{ data.orders_wait_supplier_confirm_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">已确认订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { state_in: ['confirmed'] } }">
              <p class="value">{{ data.orders_confirmed_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">面料到位订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { state_in: ['fabric_arrived'] } }">
              <p class="value">{{ data.orders_fabric_arrived_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">裁床更新订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { state_in: ['cutting_updated'] } }">
              <p class="value">{{ data.orders_cutting_updated_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">印绣花进行中订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { state_in: ['printing_in_progress'] } }">
              <p class="value">{{ data.orders_printing_in_progress_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">车间进行中订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { state_in: ['workshop_in_progress'] } }">
              <p class="value">{{ data.orders_workshop_in_progress_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">尾部进行中订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { state_in: ['tail_in_progress'] } }">
              <p class="value">{{ data.orders_tail_in_progress_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">部分完成订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { state_in: ['partial'] }}">
              <p class="value">{{ data.orders_partial_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">退厂返工订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'failed' } }">
              <p class="value">{{ data.order_delivery_failed_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">待接收辅料订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { order_accessory_deliveries_state_eq: 'submited' } }">
              <p class="value">{{ data.orders_accessory_state_submited_count || 0}}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class SupplierHome extends Vue {
  data = {
    orders_wait_supplier_confirm_count: 0,
    orders_confirmed_count: 0,
    orders_fabric_arrived_count: 0,
    orders_cutting_updated_count: 0,
    orders_printing_in_progress_count: 0,
    orders_workshop_in_progress_count: 0,
    orders_tail_in_progress_count: 0,
    orders_partial_count: 0,
    order_delivery_failed_count: 0,
    orders_accessory_state_submited_count: 0
  };

  async mounted() {
    this.data = await this.$request.get('/dashboard/supplier_role')
  }
}
</script>
